import { put, takeEvery } from "redux-saga/effects";
import { ToastContainer, toast, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as actionTypes from "./constants";
import { appConfig } from "../../config";
import { push } from "connected-react-router";
var btoa = require("Base64").btoa;

function* fetchdriverprof(params) {
  try {
    const token = localStorage.getItem("token");
    let user = JSON.parse(localStorage.getItem("user"));
    let id = user.orgId;

    let page = (params.params && params.params.page) || 1;
    let search = (params.params && params.params.search) || "";
    let filter = (params.params && params.params.filter) || "";
    let searchFilterParam = "";
    if (search) {
      searchFilterParam = `&ser=${search}`;
    }
    let filterParam = "";
    if (filter) {
      filterParam = `&status=${filter}`;
    }

    const res = yield fetch(
      `${appConfig.ip}/users?role=driver&orgId=${id}&limit=10&ser=${search}&page=${page}${filterParam}&sort=-updatedAt`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      let resJSON = yield res.json();
      yield put({
        type: actionTypes.FETCH_DRIVERPROF_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    yield put({
      type: actionTypes.FETCH_DRIVERPROF_FAIL_ACTION,
      error: err,
    });
  }
}

function* fetchdriverById(params) {
  let id = params.item.item.id;

  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/dProf/${id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch { }
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.FETCH_DRIVERBYID_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_DRIVERBYID_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}



function* deleteuser(value) {


  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));
  let id = value.value.item.id;
  let data =
    value.value.item.status === "active"
      ? { status: "suspended" }
      : { status: "active" };
  try {
    const res = yield fetch(`${appConfig.ip}/users/changeStatus/` + id, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(data),
    });
    if (!res) {
      throw res;
    } else {
      let resJSON = yield res.json();
      yield put({
        type: actionTypes.DELETE_DPROF_INIT_ACTION,
      });
      try {
        const res = yield fetch(`${appConfig.ip}/dProf/` + id, {
          method: "PUT",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify(data),
        });
        if (!res.ok) {
          let errJSON = {};
          try {
            errJSON = yield res.json();
          } catch { }
          throw Object.assign(res, errJSON);
        } else {
          let resJSON = yield res.json();
          yield put({
            type: actionTypes.DELETE_DPROF_SUCCESS_ACTION,
            payload: resJSON,
          });
          yield put({
            type: actionTypes.FETCH_DRIVERPROF_ACTION,
          });
          yield toast.success("Status change successfully", {
            autoClose: 3000,
            className:"toastClass"
          });
        }
      } catch (err) {
        yield put({
          type: actionTypes.DELETE_DPROF_FAIL_ACTION,
          error: err,
        });
      }
      yield put({
        type: actionTypes.DELETE_USER_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    yield put({
      type: actionTypes.DELETE_USER_FAIL_ACTION,
      error: err,
    });
  }
}

function* fetchCountry(action) {
  try {
    const token = localStorage.getItem("token");
    let res = yield fetch(appConfig.ip + "/country", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      let resJSON = yield res.json();
      yield put({
        type: actionTypes.FETCH_PROFCOUNTRY_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    yield put({
      type: actionTypes.FETCH_PROFCOUNTRY_FAIL_ACTION,
      error: err,
    });
  }
}

function* fetchregion(params) {
  let countryId = (params.params && params.params.countryId) || "";
  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/region?countryId=${countryId}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      let resJSON = yield res.json();
      yield put({
        type: actionTypes.FETCH_REGION_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    yield put({
      type: actionTypes.FETCH_REGION_FAIL_ACTION,
      error: err,
    });
  }
}

function* fetchlocation(params) {
  let regionId = (params.params && params.params.regionId) || null;
  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(
      `${appConfig.ip}/operatingLoc?regionId=${regionId}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      let resJSON = yield res.json();
      yield put({
        type: actionTypes.FETCH_LOCATION_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    yield put({
      type: actionTypes.FETCH_LOCATION_FAIL_ACTION,
      error: err,
    });
  }
}
function* fetchopequipment(action) {
  try {
    const token = localStorage.getItem("token");
    let res = yield fetch(appConfig.ip + "/opEquipmnt", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      let resJSON = yield res.json();
      yield put({
        type: actionTypes.FETCH_OPEQUIPMENT_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    yield put({
      type: actionTypes.FETCH_OPEQUIPMENT_FAIL_ACTION,
      error: err,
    });
  }
}
function* fetchcargotype(action) {
  try {
    const token = localStorage.getItem("token");
    let res = yield fetch(appConfig.ip + "/cargotype", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      let resJSON = yield res.json();
      yield put({
        type: actionTypes.FETCH_CARGOTYPE_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    yield put({
      type: actionTypes.FETCH_CARGOTYPE_FAIL_ACTION,
      error: err,
    });
  }
}

function* adddriverprofile(value) {


  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));

  const driveruserValue = {
    name: value.value.name,
    lName: value.value.LName,
    email: value.value.mobileNo + "@logisrunner.com",
    mobileNo: value.value.mobileNo,
    country: value.value.country,
    password: value.value.password,
    role: "driver",
    callingCode: value.value.callingCode,
    orgId: user.orgId,
    // orgName:value.value.reqType,
  };

  try {
    let res = yield fetch(appConfig.ip + "/users", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(driveruserValue),
    });

    if (!res.ok) {
      throw res;
    } else {
      let resJSON = yield res.json();

      let userId = resJSON.user.id;

      yield put({
        type: actionTypes.CREATE_DRIVERPROFILE_ACTION,
      });
      try {
        let orderData = {
          userId: userId,
          orgId: user.orgId,
          name: value.value.name,
          mobileNo: value.value.mobileNo,
          lName: value.value.LName,
          dateOfB: value.value.dateOfB,
          addr2: value.value.addr2,
          addr1: value.value.addr1,
          geoLoc: (value.value && value.value.geo) || [],
          nationality: value.value.nationality,
          region: value.value.region,
          location: value.value.location,
          city: value.value.city,
          zip: value.value.zip,
          opEquipmnt: (value.value && value.value.opEquipmnt) || [],
          cargoType: (value.value && value.value.cargoType) || [],
          resPermitNo: value.value.resPermitNo,
          // resPermitExp: value.value.resPermitExp,
          dlNo: value.value.dlNo,
          dlExpDate: value.value.dlExpDate,
          passportNo: value.value.passportNo,
          // passportExp: value.value.passportExp,
          country: value.value.country,
          ftLogin: false,
          cntryOfRes: value.value.country,
        };
        let imageData = {
          file: value.value && value.value.file,
        };
        let imagelicImg = {
          licImgFront: value.value && value.value.licImgFront,
        };

        let imagelicImgBack = {
          licImgBack: value.value && value.value.licImgBack,
        };

        let imageresPermitImg = {
          resPermitImgFront: value.value && value.value.resPermitImgFront,
        };

        let imageresPermitBack = {
          resPermitImgBack: value.value && value.value.resPermitImgBack,
        };


        let res = yield fetch(appConfig.ip + "/dProf/dProfUpsert", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify(orderData),
        });
        if (!res.ok) {
          let errJSON = {};
          try {
            errJSON = yield res.json();
          } catch { }
          throw Object.assign(res, errJSON);
        } else {
          let resJSON = yield res.json();
          yield put({
            type: actionTypes.CREATE_DRIVERPROFILE_SUCCESS_ACTION,
            payload: resJSON,
          });
          yield put({
            type: actionTypes.FETCH_DRIVERPROF_ACTION,
          });
          yield toast.success("Driver Added successfully", {
            autoClose: 3000,
            className:"toastClass"
          });
          yield put({
            type: "FETCH_DRIVER_IMG_INIT_ACTION",
            value: imageData,
            userId: userId,
          });
          yield put({
            type: "FETCH_DRIVER_LICENSEIMG_INIT_ACTION",
            value: imagelicImg,
            userId: userId,
          });
          yield put({
            type: "FETCH_LICENSEBACKIMG_INIT_ACTION",
            value: imagelicImgBack,
            userId: userId,
          });
          yield put({
            type: "FETCH_RESPERMITFRONTIMG_INIT_ACTION",
            value: imageresPermitImg,
            userId: userId,
          });
          yield put({
            type: "FETCH_RESPERMITBACKIMG_INIT_ACTION",
            value: imageresPermitBack,
            userId: userId,
          });
        }
      } catch (err) {
        yield put({
          type: actionTypes.CREATE_DRIVERPROFILE_FAIL_ACTION,
          error: err,
        });
      }
      yield put({
        type: actionTypes.ADD_DRIVERPROFILE_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.status === 409) {
      yield toast.error(
        "Mobile number used is already registered. Please try with another number",
        {
          autoClose: 3000,
          transition: Flip,
          className:"toastClass"
        }
      );
    } else {
      yield toast.error(
        "Sorry, we were not able to add the driver. try after sometime",
        {
          autoClose: 3000,
          transition: Flip,
          className:"toastClass"
        }
      );
      yield put({
        type: actionTypes.ADD_DRIVERPROFILE_FAIL_ACTION,
        error: err,
      });
    }
  }
}

function* addDriverImg(value) {
  try {
    const data = new FormData();

    data.append(value.userId, value.value.file, value.value.file.name);

    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/users/image`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: data,
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch { }
      throw Object.assign(res, errJSON);
    } else {
    }
  } catch (err) {

    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_DRIVER_IMG_INIT_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* addDriverlicImg(value) {
  try {
    const data = new FormData();

    data.append(
      value.userId + "-licFront",
      value.value.licImgFront,
      value.value.licImgFront.name
    );
    data.append("imgType", "licImgFront");
    data.append("userId", value.userId);

    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/dProf/licImg`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: data,
    });
    if (!res.ok) {
      let errJSON = {};
      yield put({
        type: actionTypes.FETCH_DRIVER_LICENSEIMG_SUCCESS_ACTION,
        payload: errJSON,
      });
      try {
        errJSON = yield res.json();
      } catch { }
      throw Object.assign(res, errJSON);
    } else {
    }
  } catch (err) {

    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_DRIVER_LICENSEIMG_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* addDriverlicImgBack(value) {
  try {
    const data = new FormData();

    data.append(
      value.userId + "-licBack",
      value.value.licImgBack,
      value.value.licImgBack.name
    );
    data.append("imgType", "licImgBack");
    data.append("userId", value.userId);

    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/dProf/licImg`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: data,
    });
    if (!res.ok) {
      let errJSON = {};
      yield put({
        type: actionTypes.FETCH_LICENSEBACKIMG_SUCCESS_ACTION,
        payload: errJSON,
      });
      try {
        errJSON = yield res.json();
      } catch { }
      throw Object.assign(res, errJSON);
    } else {
    }
  } catch (err) {

    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_LICENSEBACKIMG_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* addresPermitImg(value) {


  try {
    const data = new FormData();

    data.append(
      value.userId + "-resPermitFront",
      value.value.resPermitImgFront,
      value.value.resPermitImgFront.name
    );
    data.append("imgType", "resPermitImgFront");
    data.append("userId", value.userId);

    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/dProf/resPermitImg`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: data,
    });
    if (!res.ok) {
      let errJSON = {};
      yield put({
        type: actionTypes.FETCH_RESPERMITFRONTIMG_SUCCESS_ACTION,
        payload: errJSON,
      });
      try {
        errJSON = yield res.json();
      } catch { }
      throw Object.assign(res, errJSON);
    } else {
    }
  } catch (err) {

    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_RESPERMITFRONTIMG_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* addresPermitBack(value) {
  try {
    const data = new FormData();

    data.append(
      value.userId + "-resPermitBack",
      value.value.resPermitImgBack,
      value.value.resPermitImgBack.name
    );
    data.append("imgType", "resPermitImgBack");
    data.append("userId", value.userId);

    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/dProf/resPermitImg`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: data,
    });
    if (!res.ok) {
      let errJSON = {};
      yield put({
        type: actionTypes.FETCH_RESPERMITBACKIMG_SUCCESS_ACTION,
        payload: errJSON,
      });
      try {
        errJSON = yield res.json();
      } catch { }
      throw Object.assign(res, errJSON);
    } else {
    }
  } catch (err) {

    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_RESPERMITBACKIMG_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* fetchopendrivers(params) {
  try {
    const token = localStorage.getItem("token");
    let user = JSON.parse(localStorage.getItem("user"));
    let id = user.orgId;

    let page = (params.params && params.params.page) || 1;
    let search = (params.params && params.params.search) || "";
    let filter = (params.params && params.params.filter) || "";
    let searchFilterParam = "";
    if (search) {
      searchFilterParam = `&ser=${search}`;
    }
    let filterParam = "";
    if (filter) {
      filterParam = `&status=${filter}`;
    }
    const res = yield fetch(
      `${appConfig.ip}/users?role=driver&orgId=open&ftLogin=false&limit=10&ser=${search}&page=${page}${filterParam}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      let resJSON = yield res.json();
      yield put({
        type: actionTypes.FETCH_OPENDRIVER_SUCCESS_ACTION,
        payload: resJSON,
      });

    }
  } catch (err) {
    yield put({
      type: actionTypes.FETCH_OPENDRIVER_FAIL_ACTION,
      error: err,
    });
  }
}

function* attachDriver(value) {


  let id = value.value.item.id;

  let user = JSON.parse(localStorage.getItem("user"));

  let data = {
    userId: value.value.item.id,
    orgId: user.orgId,
    attached: true,
    ftLogin: false,
  };

  const token = localStorage.getItem("token");
  try {
    const res = yield fetch(`${appConfig.ip}/dProf/${id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(data),
    });
    if (!res) {
      throw res;
    } else {
      let resJSON = yield res.json();

      yield put({
        type: actionTypes.UPDATE_USERPROF_ACTION,
      });
      try {
        let orderData = {
          role: "driver",
          orgId: user.orgId,
        };

        const res = yield fetch(`${appConfig.ip}/users/updateUser/${id}`, {
          method: "PUT",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify(orderData),
        });
        if (!res.ok) {
          let errJSON = {};
          try {
            errJSON = yield res.json();
          } catch { }
          throw Object.assign(res, errJSON);
        } else {
          let resJSON = yield res.json();
          yield put({
            type: actionTypes.UPDATE_USERPROF_SUCCESS_ACTION,
            payload: resJSON,
          });
        }
      } catch (err) {
        yield put({
          type: actionTypes.UPDATE_USERPROF_FAIL_ACTION,
          error: err,
        });
      }
      yield toast.success(" Driver attached successfully", {
        autoClose: 3000,
        className:"toastClass"
      });
      yield put({
        type: actionTypes.ATTACH_DRIVER_SUCCESS_ACTION,
        payload: resJSON,
      });
      yield put({
        type: actionTypes.FETCH_OPENDRIVER_ACTION,
      });
    }
  } catch (err) {
    yield put({
      type: actionTypes.ATTACH_DRIVER_FAIL_ACTION,
      error: err,
    });
  }
}

function* dettachDriver(value) {
  let id = value.value.item.id;

  let user = JSON.parse(localStorage.getItem("user"));

  let data = {
    userId: value.value.item.id,
    orgId: "open",
    attached: false,
    ftLogin: false,
  };

  const token = localStorage.getItem("token");
  try {
    const res = yield fetch(`${appConfig.ip}/dProf/${id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(data),
    });
    if (!res) {
      throw res;
    } else {
      let resJSON = yield res.json();

      yield put({
        type: actionTypes.UPDATE_USERPROF_ACTION,
      });
      try {
        let orderData = {
          role: "driver",
          orgId: "open",
        };

        const res = yield fetch(`${appConfig.ip}/users/updateUser/${id}`, {
          method: "PUT",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify(orderData),
        });
        if (!res.ok) {
          let errJSON = {};
          try {
            errJSON = yield res.json();
          } catch { }
          throw Object.assign(res, errJSON);
        } else {
          let resJSON = yield res.json();
          yield put({
            type: actionTypes.UPDATE_USERPROF_SUCCESS_ACTION,
            payload: resJSON,
          });
        }
      } catch (err) {
        yield put({
          type: actionTypes.UPDATE_USERPROF_FAIL_ACTION,
          error: err,
        });
      }
      yield put({
        type: actionTypes.DETTACH_DRIVER_SUCCESS_ACTION,
        payload: resJSON,
      });
      yield toast.success("Driver dettached successfully", {
        autoClose: 3000,
        className:"toastClass"
      });
      yield put({
        type: actionTypes.FETCH_DRIVERPROF_ACTION,
      });
    }
  } catch (err) {
    yield put({
      type: actionTypes.DETTACH_DRIVER_FAIL_ACTION,
      error: err,
    });
  }
}

function* editdriverprofile(value) {


  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));
  const driverData = {
    userId: value.value.userId,
    orgId: user.orgId,
    name: value.value.name,
    lName: value.value.LName,
    dateOfB: value.value.dateOfB,
    addr1: value.value.addr1,
    addr2: value.value.addr2,
    geoLoc: value.value.geoLoc,
    nationality: value.value.nationality,
    cntryOfRes: value.value.country,
    region: value.value.region,
    location: value.value.location,
    city: value.value.city,
    zip: value.value.zip,
    resPermitNo: value.value.resPermitNo,
    // resPermitExp: value.value.resPermitExp,
    dlNo: value.value.dlNo,
    dlExpDate: value.value.dlExpDate,
    passportNo: value.value.passportNo,
    // passportExp: value.value.passportExp,
    mobileNo: value.value.mobileNo,
    // licImg:value.value.licImg,
    // opEquipmnt: opArr,
    // cargoType: cargoArr,

    ftLogin: false,
  };

  let imageData = {
    file: value.value && value.value.file,
  };
  let imagelicImg = {
    licImgFront: value.value && value.value.licImgFront,
  };

  let imagelicImgBack = {
    licImgBack: value.value && value.value.licImgBack,
  };

  let imageresPermitImg = {
    resPermitImgFront: value.value && value.value.resPermitImgFront,
  };

  let imageresPermitBack = {
    resPermitImgBack: value.value && value.value.resPermitImgBack,
  };


  try {
    const res = yield fetch(`${appConfig.ip}/dProf/dProfUpsert/`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(driverData),
    });

    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {
        throw Object.assign(res, errJSON);
      }
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.EDIT_DRIVERPROFILE_SUCCESS_ACTION,
      });
      yield put({
        type: actionTypes.FETCH_DRIVERPROF_ACTION,
      });
      yield toast.success("Driver updated successfully", {
        autoClose: 3000,
        className:"toastClass"
      });
      yield put({
        type: "FETCH_DRIVER_IMG_INIT_ACTION",
        value: imageData,
        userId: value.value.userId,
      });
      yield put({
        type: "FETCH_DRIVER_LICENSEIMG_INIT_ACTION",
        value: imagelicImg,
        userId: value.value.userId,
      });
      yield put({
        type: "FETCH_LICENSEBACKIMG_INIT_ACTION",
        value: imagelicImgBack,
        userId: value.value.userId,
      });
      yield put({
        type: "FETCH_RESPERMITFRONTIMG_INIT_ACTION",
        value: imageresPermitImg,
        userId: value.value.userId,
      });
      yield put({
        type: "FETCH_RESPERMITBACKIMG_INIT_ACTION",
        value: imageresPermitBack,
        userId: value.value.userId,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.EDIT_DRIVERPROFILE_FAIL_ACTION,
        error: err,
      });
    }
  }
}




function* fetchdriverTrip(params) {

  let id = params.item.item.id;
  // let page = (params.item.item && params.item.item.page) || 1;
  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/trip?driver=${id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch { }
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.FETCH_DRIVERTRIP_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_DRIVERTRIP_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}






export function* MyDriversActionWatcher() {
  yield takeEvery(actionTypes.FETCH_DRIVERPROF_ACTION, fetchdriverprof);
  yield takeEvery(actionTypes.FETCH_DRIVERBYID_ACTION, fetchdriverById);
  yield takeEvery(actionTypes.DELETE_USER_INIT_ACTION, deleteuser);
  yield takeEvery(actionTypes.FETCH_PROFCOUNTRY_ACTION, fetchCountry);
  yield takeEvery(actionTypes.FETCH_REGION_ACTION, fetchregion);
  yield takeEvery(actionTypes.FETCH_LOCATION_ACTION, fetchlocation);
  yield takeEvery(actionTypes.FETCH_OPEQUIPMENT_ACTION, fetchopequipment);
  yield takeEvery(actionTypes.FETCH_CARGOTYPE_ACTION, fetchcargotype);
  yield takeEvery(actionTypes.ADD_DRIVERPROFILE_ACTION, adddriverprofile);
  yield takeEvery(actionTypes.FETCH_DRIVER_IMG_INIT_ACTION, addDriverImg);
  yield takeEvery(actionTypes.FETCH_OPENDRIVER_ACTION, fetchopendrivers);
  yield takeEvery(actionTypes.ATTACH_DRIVER_ACTION, attachDriver);
  yield takeEvery(actionTypes.DETTACH_DRIVER_ACTION, dettachDriver);
  yield takeEvery(actionTypes.EDIT_DRIVERPROFILE_ACTION, editdriverprofile);
  yield takeEvery(
    actionTypes.FETCH_DRIVER_LICENSEIMG_INIT_ACTION,
    addDriverlicImg
  );
  yield takeEvery(
    actionTypes.FETCH_LICENSEBACKIMG_INIT_ACTION,
    addDriverlicImgBack
  );
  yield takeEvery(
    actionTypes.FETCH_RESPERMITFRONTIMG_INIT_ACTION,
    addresPermitImg
  );
  yield takeEvery(
    actionTypes.FETCH_RESPERMITBACKIMG_INIT_ACTION,
    addresPermitBack
  );
  yield takeEvery(
    actionTypes.FETCH_DRIVERTRIP_ACTION,
    fetchdriverTrip
  );
}
